<h3 class="title">General</h3>
<blaze-api-general-card class="mb-16" />

<h3 class="title">Actions ({{ actionCount$ | async }})</h3>
@for (action of actions$ | async; track action.id) {
  <blaze-api-action-card
    [action]="action"
    [accountId]="accountId"
    [canDeleteAction]="(canDeleteAction$ | async) || false"
    [showValidation]="showValidation"
    (actionChange)="updateAction($event)"
  />
}

<div class="flex mt-24 px-16">
  <button blazeButton (click)="addNewAction()"> ADD NEW ACTION </button>
</div>
